import React from 'react';
import Homepage from './pages/Homepage/Homepage';
import './App.scss';

function App() {
  return (
    <div className="App">
        <Homepage />
    </div>
  );
}

export default App;
